<section id="container">
  <app-menu></app-menu>
  <section id="main-content">
    <section class="wrapper">
      <div class="header">
        <h3
          i18n="contact list page title|The title of the contact list page shown to authenticated users@@contactListPageTitle"
          class="title"
        >Contact List</h3>
        <div class="actions">
          <button
            class="btn btn-primary btn-with-left-icon"
            (click)="modalService.open(bulkModal)"
          >
            <i class="fa fa-plus"></i>
            <span i18n="button to import contacts at contact list page|The button to Import Contacts at the contact list page header@@importContactsButtonLabelContactListPage">Import Contacts</span>
          </button>
          <button
            class="btn btn-primary btn-with-left-icon"
            (click)="onAddClick()"
          >
            <i class="fa fa-plus"></i>
            <span i18n="button to add contact at contact list page|The button to Add Contact at the contact list page header@@addContactButtonLabelContactListPage">Add Contact</span>
          </button>
          <button
            *ngIf="contactOptionList"
            [disabled]="(selectedContacts()==0)"
            class="btn btn-danger btn-with-left-icon"
            (click)="onBulkRemoveClick(modalBulkDelete)"
          >
            <i class="fa fa-trash"></i>
            <span i18n="button to delete contact at contact list page|The button to Delete Contact at the contact list page header@@deleteContactButtonLabelContactListPage">Delete Contact(s)</span>
          </button>
          <button
            *ngIf="contactOptionList"
            [disabled]="(selectedContacts()==0)"
            class="btn btn-info btn-with-left-icon"
            (click)="onBulkSendPdfPasswordClick()"
          >
            <i class="fa fa-trash"></i>
            <span i18n="button to pdf password at contact list page|The button to PDF Password at the contact list page header@@pdfPasswordButtonLabelContactListPage">Send PDF Password(s)</span>
          </button>
        </div>
      </div>
      <table class='table table-striped table-advance table-hover' *ngIf="contactOptionList">
        <thead>
          <tr>
            <th class="check"><input type="checkbox" [checked]="isAllSelected()" (click)="onSelectContact()"
                [indeterminate]="allIntermediate()"></th>
            <th *ngFor="let header of headers; index as i" [ngClass]="header.class">
              <div class="filter-table-header" [attr.data-index]="i">
                <span class="label">{{ header.label }}</span>
                <div class="button-group">
                  <button *ngIf="header.filter && header.filter.value" class="btn btn-xs btn-gray btn-clear-filter"
                    (click)="onClearFilterClick(header)">
                    <i class="fa fa-remove"></i>
                  </button>
                  <button *ngIf="header.filter && header.filter.property" class="btn btn-xs btn-gray btn-filter">
                    <span class="icon-stack">
                      <i class="fa fa-filter icon-stack-base"></i>
                      <i *ngIf="header.filter.value" class="fa fa-check icon-checkmark"></i>
                    </span>
                  </button>
                </div>
                <div class="filter-input-height-limit">
                  <div *ngIf="header.filter && header.filter.property && header.filter.open"
                    class="filter-input-wrapper">
                    <input
                      [ngStyle]="{'width': header.filter.width + 'px'}"
                      type="text"
                      [attr.data-property]="header.filter.property"
                      (change)="onFilterChange()"
                      (keyup)="onFilterChange()"
                      value="{{ header.filter.value }}"
                      class="form-control filter-input"
                    />
                  </div>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody *ngIf="filteredContactOptionList.length === 0 && contactOptionList.length === 0">
          <tr><td colspan="9" i18n="@@contactListEmptyNotice">There are no contacts to show</td></tr>
        </tbody>
        <tbody *ngIf="filteredContactOptionList.length === 0 && contactOptionList.length !== 0">
          <tr><td colspan="9" i18n="@@noMatchingContactsForFilterNotice">There are no matching contacts for this filter</td></tr>
        </tbody>
        <tbody *ngIf="filteredContactOptionList.length !== 0">
          <tr *ngFor="let option of filteredContactOptionList">
            <ng-container *ngIf="option.isLoading">
              <td><input type="checkbox" [(ngModel)]="option.isSelected"></td>
              <td colspan="7">
                <div class="loading-wrapper"><i class="fa fa-circle-o-notch fa-spin-fast"></i></div>
              </td>
              <td class="actions">
                <button class="btn btn-primary btn-xs" disabled><span class="fa fa-pencil"></span></button>
                <button class="btn btn-danger btn-xs" disabled><span class="fa fa-trash "></span></button>
              </td>
            </ng-container>
            <ng-container *ngIf="!option.isLoading">
              <td class="check"><input type="checkbox" [(ngModel)]="option.isSelected"></td>
              <td class="name">{{ option.contact.name }}</td>
              <td class="email">{{ option.contact.email }}</td>
              <td class="phone">{{ option.contact.phone }}</td>
              <td class="tags">
                <button class="btn btn-flat btn-xs" *ngFor="let tag of getTagArrayFromString(option.contact.tags)" (click)="onTagClick(tag)">{{ tag }}</button>
              </td>
              <td class="department">{{ option.contact.department }}</td>
              <td class="company">{{ option.contact.company }}</td>
              <td class="password" *ngIf="option.contact.pdfpassword" i18n="indication of existance of pdf password|The text that conveys that a specific contact has an active PDF Password@@indicationActivePdfPassword">Yes</td>
              <td class="password" *ngIf="!option.contact.pdfpassword" i18n="indication of inexistance of pdf password|The text that conveys that a specific contact does not have an active PDF Password@@indicationInactivePdfPassword">No</td>
              <td class="actions">
                <button class="btn btn-primary btn-xs" (click)="onEditClick(option)"><span
                    class="fa fa-pencil"></span></button>
                <button class="btn btn-danger btn-xs" (click)="onRemoveClick(contentModal, option)"><span
                    class="fa fa-trash "></span></button>
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </section>
  </section>
</section>

<ng-template #contentModal let-modal>
  <div class="modal-header">
    <h4
      class="modal-title"
      i18n="contact removal modal title|Title for the remove contact modal at the contact list page@@contactRemovalModalTitle"
    >Remove Contact</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Close')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <section class="loading-wrapper" *ngIf="isLoadingTasks">
      <div class="row">
        <div class="col-12 text-center">
          <i class="fa fa-circle-o-notch fa-spin fa-2x"></i>
        </div>
        <div
          class="col-12 loading-text"
          i18n="indication of loading contact tasks|A text to indicate that the list of tasks are being loaded before another action can be executed at the contact list@@modalContactLoadingTasksModal"
        >Loading linked Tasks</div>
      </div>
    </section>
    <section *ngIf="!isLoadingTasks">
      <h6 i18n="contact removal confirmation title|The main title to the remove contact confirmation dialog@@contactRemovalConfirmationTitle">Are you sure you want to remove this contact?</h6>
      <p i18n="action cannot be undone text|The generic warning that an action cannot be undone@@actionCannotBeUndoneWarning">This action cannot be undone.</p>
      <p *ngIf="contactTasks.length > 0">
        <span>{{ contactTasks.length + " " }}</span>
        <span
          *ngIf="contactTasks.length === 1"
          i18n="singular task linked with contact suffix|The suffix right after the number 1, which is the number of tasks that are connected to the contact, letting the user know about the impacts of the deletion of the contact@@singularConnectedTaskAmountContactRemoval"
        >task is linked with this contact</span>
        <span
          *ngIf="contactTasks.length > 1"
          i18n="plural task linked with contact suffix|The suffix after the number of tasks (larger than one) that are connected to the contact, letting the user know about the impacts of the deletion of the contact@@pluralConnectedTaskAmountContactRemoval"
        >tasks are linked with this contact</span>
        <button (click)="showTasks()" class="btn btn-sm btn-info">
          <span
            *ngIf="viewTasks"
            i18n="hide tasks connected to user button label|The label of the button used to hide tasks that that are connected to a contact or contacts that are selected for removal@@hideRemovalContactConnectedTaskButtonLabel"
          >Hide tasks</span>
          <span
            *ngIf="!viewTasks"
            i18n="show tasks connected to user button label|The label of the button used to show tasks that that are connected to a contact or contacts that are selected for removal@@showRemovalContactConnectedTaskButtonLabel"
          >View tasks</span>
        </button>
      </p>
      <p *ngIf="skippedTasks() > 0">
        <span>{{ skippedTasks() + " " }}</span>
        <span
          *ngIf="contactTasks.length === 1"
          i18n="singular task being disabled with contact removal suffix|The suffix after the number of tasks (1) that will be disabled once the selected contact gets deleted@@singularTaskAmountBeingDisabledContactRemoval"
        >task will no longer be performed</span>
        <span
          *ngIf="contactTasks.length > 1"
          i18n="plural task being disabled with contact removal suffix|The suffix after the number of tasks (more than 1) that will be disabled once the selected contact gets delete@@pluralTaskAmountBeingDisabledContactRemoval"
        >tasks will no longer be performed</span>
      </p>
      <div *ngIf="viewTasks" class="task-card card">
        <div class="card-body">
          <p><strong>Tasks</strong></p>
          <ul class="task-list">
            <li title="{{option.reportContacts==0 ?'This contact is the only one for this task':''}}"
              *ngFor="let option of contactTasks">
              <span [ngClass]="{'font-weight-bold':option.reportContacts==0}">
                {{ option.name }}
                <span *ngIf="option.reportContacts==0">*</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-dark"
      (click)="modal.close('Cancel')"
      i18n="submit contact removal cancel button label|The label of the button that allows the user to cancel the deletion of a contact at the confirmation modal@@cancelContactRemovalActionButtonLabel"
    >Cancel</button>
    <button
      type="button"
      class="btn btn-danger"
      [disabled]="isLoadingTasks"
      (click)="modal.close('Remove')"
      i18n="submit contact removal action button label|The label of the button that allows the user to confirm the desire to delete a contact at the confirmation modal@@submitContactRemovalActionButtonLabel"
    >Remove</button>
  </div>
</ng-template>

<ng-template #modalBulkDelete let-modal>
  <div class="modal-header">
    <h4 class="modal-title"
      i18n="contact removal modal title|Title for the remove contact modal at the contact list page@@contactRemovalModalTitle">Remove Contact(s)</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Close');clearModalBRError()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <section class="loading-wrapper" *ngIf="isLoadingTasks">
      <div class="row">
        <div class="col-12 text-center">
          <i class="fa fa-circle-o-notch fa-spin fa-2x"></i>
        </div>
        <div
          class="col-12 loading-text"
          i18n="indication of loading contact tasks|A text to indicate that the list of tasks are being loaded before another action can be executed at the contact list@@modalContactLoadingTasksModal"
        >Loading linked Tasks</div>
      </div>
    </section>
    <section *ngIf="!isLoadingTasks">
    <h6 *ngIf="selectedContacts() === 1" i18n="confirm bulk removal of a single contact|A text confirming the user wants to remove a single contact from the contact list in the bulk delete modal@@confirmBulkRemovalSingularContact">Are you sure you want to remove this contact?</h6>
    <h6 *ngIf="selectedContacts() !== 1" i18n="confirm bulk removal of multiple contacts|A text confirming the user wants to remove multiple contacts from the contact list in the bulk delete modal@@confirmBulkRemovalSingularContact">Are you sure you want to remove {{ selectedContacts() }} contact(s)?</h6>
    <p i18n="action cannot be undone text|The generic warning that an action cannot be undone@@actionCannotBeUndoneWarning">This action cannot be undone.</p>
    <div *ngIf="modalBulkRemErrorMesssage!=''" class="alert alert-danger">
      {{modalBulkRemErrorMesssage}}
    </div>
    <p *ngIf="contactTasks.length>0">
      <span>{{ contactTasks.length + " " }}</span>
      <span
        *ngIf="contactTasks.length === 1"
        i18n="singular task linked with contact suffix|The suffix right after the number 1, which is the number of tasks that are connected to the contact, letting the user know about the impacts of the deletion of the contact@@singularConnectedTaskAmountContactRemoval"
      >task is linked with this contact</span>
      <span
        *ngIf="contactTasks.length > 1"
        i18n="plural task linked with contact suffix|The suffix after the number of tasks (larger than one) that are connected to the contact, letting the user know about the impacts of the deletion of the contact@@pluralConnectedTaskAmountContactRemoval"
      >tasks are linked with this contact</span>
    </p>
    <p *ngIf="skippedTasks() > 0">
      <span>{{ skippedTasks() + " " }}</span>
      <span
        *ngIf="contactTasks.length === 1"
        i18n="singular task being disabled with contact removal suffix|The suffix after the number of tasks (1) that will be disabled once the selected contact gets deleted@@singularTaskAmountBeingDisabledContactRemoval"
      >task will no longer be performed</span>
      <span
        *ngIf="contactTasks.length > 1"
        i18n="plural task being disabled with contact removal suffix|The suffix after the number of tasks (more than 1) that will be disabled once the selected contact gets delete@@pluralTaskAmountBeingDisabledContactRemoval"
      >tasks will no longer be performed</span>
      <button (click)="showTasks()" class="btn btn-sm btn-info">
        <span
          *ngIf="viewTasks"
          i18n="hide tasks connected to user button label|The label of the button used to hide tasks that that are connected to a contact or contacts that are selected for removal@@hideRemovalContactConnectedTaskButtonLabel"
        >Hide tasks</span>
        <span
          *ngIf="!viewTasks"
          i18n="show tasks connected to user button label|The label of the button used to show tasks that that are connected to a contact or contacts that are selected for removal@@showRemovalContactConnectedTaskButtonLabel"
        >View tasks</span>
      </button>
    </p>
    <div *ngIf="viewTasks" class="task-card card">
      <div class="card-body">
        <p><strong>Tasks</strong></p>
        <ul class="task-list">
          <li title="{{option.reportContacts==0 ?'This contact is the only one for this task':''}}"
            *ngFor="let option of contactTasks">
            <span [ngClass]="{'font-weight-bold':option.reportContacts==0}">
              {{option.name}}
              <span *ngIf="option.reportContacts==0">*</span>
            </span>
          </li>
        </ul>
      </div>

    </div>
  </section>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-dark"
      (click)="modal.close('Cancel');clearModalBRError()"
      i18n="submit bulk contact removal cancel button label|The label of the button that allows the user to cancel the deletion of a bulk contact at the confirmation modal@@cancelBulkContactRemovalActionButtonLabel"
    >Cancel</button>
    <button
      type="button"
      [disabled]="isLoadingTasks"
      class="btn btn-danger"
      (click)="bulkRemove();clearModalBRError()"
      i18n="submit bulk contact removal action button label|The label of the button that allows the user to confirm the desire to delete a bulk contact at the confirmation modal@@submitBulkContactRemovalActionButtonLabel"
    >Remove</button>
  </div>
</ng-template>

<ng-template #bulkModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Contact - Bulk Insert</h4>
    <button type="button" class="close" aria-label="Close" (click)="clearModalBAError(modal)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modal-bulk">
    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text" id="inputGroupFileAddon01">Upload</span>
      </div>
      <div class="custom-file">
        <input class="custom-file-input" type="file" id="file"
          (change)="handleFileInput($event.target.files,$event.target)" aria-describedby="inputGroupFileAddon01">
        <label class="custom-file-label" for="inputGroupFile01">{{fileToUpload?fileToUpload.name:"Choose file"}}</label>
      </div>
    </div>

    <div *ngIf="modalErrorMesssage!=''" class="alert alert-danger">
      {{modalErrorMesssage}}
    </div>
    <div *ngIf="importResultData && importResultData.errors.length==0" class="alert alert-info">
      All Contacts has been imported!
    </div>
    <div class="form-group udapte-contact">
      <label>Update contact if exists </label>
      <div class="btn-group btn-group-justified">
        <div class="btn-group">
          <button type="button"
            [ngClass]="{'btn': true, 'btn-default': !isEnabledUpdateBulk, 'btn-info': isEnabledUpdateBulk, 'disabled': isEnabledUpdateBulk}"
            (click)="onUpdateSwitch(true)">Enabled</button>
        </div>
        <div class="btn-group">
          <button type="button"
            [ngClass]="{'btn': true, 'btn-default': isEnabledUpdateBulk, 'btn-info': !isEnabledUpdateBulk, 'disabled': !isEnabledUpdateBulk}"
            (click)="onUpdateSwitch(false)">Disabled</button>
        </div>
      </div>
    </div>

    <div *ngIf="importResultData && importResultData.errors.length>0" class="alert alert-warning">
      <div>Imported Contacts: {{importResultData.success}}</div>
      <div *ngIf="isEnabledUpdateBulk">Updated Contacts: {{importResultData.updated}}</div>
      <div>Errors: {{importResultData.errors.length}} <span class="btn btn-sm"
          (click)="collapseErrors()">{{showImportErrors?'Hide':'View'}} Errors</span></div>
    </div>
    <div *ngIf="showImportErrors" class="card import-errors">
      <app-tree-view [data]="importResultData.treeData"></app-tree-view>
    </div>
    <a class="btn btn-block btn-info btn-download" href="{{templateFileUrl}}">Download Template</a>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="clearModalBAError(modal)">Close</button>
    <button [disabled]="!(fileToUpload) || sendingFile" type="button" class="btn btn-info btn-with-left-icon"
      (click)="sendFile()">
      <i *ngIf="sendingFile" class="fa fa-circle-o-notch fa-spin"></i>
      <i *ngIf="!sendingFile" class="fa fa-rocket"></i>
      Send
    </button>
  </div>
</ng-template>
